module.exports = __webpack_public_path__ + "img/box-09.df133026.jpg";